import Parse from 'parse'

const state = {
  options: []
}

const getters = {
  accountTypes: (state) => {
    return state.options.filter((o) => {
      return o.get('category') === 'accountType'
    })
  }
}

const mutations = {
  setOptions (state, options) {
    state.options = options
  }
}

const actions = {
  async retrieveOptions ({ commit }) {
    const query = new Parse.Query('Option')
    commit('setOptions', await query.find())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
